/**
 * CP-355: the "Dates, price & more" panel edits a draft; only Apply commits it.
 *
 * The chips above the grid and the toggle's count describe what the results
 * were fetched with, so they are built from the APPLIED state (the URL), never
 * from the draft. A pending pick (e.g. Balcony, before Apply) shows nothing
 * outside the panel while the cards still carry the old prices. Closing the
 * panel without applying drops the draft back to the applied values.
 */

// Fields the panel holds as a draft until Apply (the chips, duration and sort
// apply immediately and are not part of the draft).
export const PANEL_DRAFT_KEYS = [
  'departure_port',
  'ship_name',
  'start_date',
  'end_date',
  'cabin',
  'min_price',
  'max_price'
];

function hasPrice(v) {
  return v != null && v !== '';
}

/**
 * Chips for the applied panel fields, in display order.
 * `applied` is browseStateFromQuery(route.query); `fmt` = { port(key) -> label,
 * price(n) -> string }.
 */
export function appliedPanelChips(applied, fmt) {
  const a = applied || {};
  const f = fmt || {};
  const port = f.port || ((k) => k);
  const price = f.price || ((n) => String(n));
  const chips = [];
  if (a.departure_port) {
    chips.push({ key: 'departure_port', label: `From ${port(a.departure_port)}`, field: 'departure_port' });
  }
  if (a.ship_name) chips.push({ key: 'ship_name', label: a.ship_name, field: 'ship_name' });
  if (a.start_date) chips.push({ key: 'start_date', label: `From ${a.start_date}`, field: 'start_date' });
  if (a.end_date) chips.push({ key: 'end_date', label: `Until ${a.end_date}`, field: 'end_date' });
  if (a.cabin) chips.push({ key: 'cabin', label: `${a.cabin} cabin`, field: 'cabin' });
  if (hasPrice(a.min_price)) chips.push({ key: 'min_price', label: `Min $${price(a.min_price)}`, field: 'min_price' });
  if (hasPrice(a.max_price)) chips.push({ key: 'max_price', label: `Max $${price(a.max_price)}`, field: 'max_price' });
  return chips;
}

/**
 * The draft values that differ from the applied state, as { key: appliedValue }.
 * Empty when the panel already shows what is applied.
 */
export function panelDraftReverts(draft, applied) {
  const d = draft || {};
  const a = applied || {};
  const out = {};
  PANEL_DRAFT_KEYS.forEach((key) => {
    if (d[key] !== a[key]) out[key] = a[key];
  });
  return out;
}
